import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import './BrokerApplicationForm.scss';
import { actions } from '../redux/brokerApplicationActions';
import BrokerApplicationForm from '../components/BrokerApplicationForm/BrokerApplicationForm';
import Loader from '../../../common/components/Loader/Loader';
import { getAvailableProducts } from '../../broker/helpers';

const BrokerApplicationEditContainer = ({
  params: { id },
  getBrokerApplication,
  updateBrokerApplication,
  clearExistingOrganisation,
  resendBrokerApplication,
  declineBrokerApplication,
  saveAndApproveBrokerApplication,
  getProductInsurers,
  user,
  brokerApplication,
}) => {
  useEffect(
    () => {
      getBrokerApplication(id);
      getProductInsurers();
    },
    [id, getBrokerApplication, getProductInsurers],
  );

  const update = (resource) => {
    return updateBrokerApplication(resource);
  };
  const availableProducts = useMemo(() => getAvailableProducts(user), [user]);

  const resource = brokerApplication.resources[id];

  if (!resource?.data || !brokerApplication?.productInsurers?.length) {
    return <Loader />;
  }

  return (
    <BrokerApplicationForm
      availableProducts={availableProducts}
      onClearExistingOrganisation={clearExistingOrganisation}
      onSaveAndApproveBrokerApplication={saveAndApproveBrokerApplication}
      onResendBrokerApplication={resendBrokerApplication}
      onDeclineBrokerApplication={declineBrokerApplication}
      onUpdate={update}
      resource={resource}
      insurers={brokerApplication?.productInsurers}
      isSubmitting={brokerApplication.isSubmitting}
    />
  );
};

export default connect(
  (state) => {
    return {
      brokerApplication: state.brokerApplication,
      user: state.auth.user,
    };
  },
  {
    createBrokerApplication: actions.createBrokerApplication,
    updateBrokerApplication: actions.updateBrokerApplication,
    declineBrokerApplication: actions.declineBrokerApplication,
    saveAndApproveBrokerApplication: actions.saveAndApproveBrokerApplication,
    resendBrokerApplication: actions.resendBrokerApplication,
    clearExistingOrganisation: actions.clearExistingOrganisation,
    getProductInsurers: actions.getProductInsurers,
    getBrokerApplication: actions.getBrokerApplication,
  },
)(BrokerApplicationEditContainer);
